import { FC } from 'react';

import {
  GiftCouponRedeemStatus,
  GiftCouponStatistics,
} from '@shared/api/giftCoupon/giftCoupon.interface';

interface StatsCardsProps {
  statistics: GiftCouponStatistics | null;
  showBlacklist: boolean;
  onToggleBlacklist: () => void;
  onSearchByStatus: (status: GiftCouponRedeemStatus) => void;
  redeemStatus: string;
  hasSearched: boolean;
}

export const StatsCards: FC<StatsCardsProps> = ({
  statistics,
  showBlacklist,
  onToggleBlacklist,
  onSearchByStatus,
  redeemStatus,
  hasSearched,
}) => {
  return (
    <div className="grid grid-cols-7 gap-3 p-4">
      <div className="rounded-lg bg-yellow-50 p-3 text-center">
        <p className="text-lg font-bold text-yellow-700">
          {statistics?.pending ?? '-'}
        </p>
        <p className="text-xs text-yellow-600">발송 대기</p>
      </div>
      <div className="rounded-lg bg-green-50 p-3 text-center">
        <p className="text-lg font-bold text-green-700">
          {statistics?.delivered ?? '-'}
        </p>
        <p className="text-xs text-green-600">발송 완료</p>
      </div>
      <div className="rounded-lg bg-gray-100 p-3 text-center">
        <p className="text-lg font-bold text-gray-700">{statistics?.total ?? '-'}</p>
        <p className="text-xs text-gray-600">전체</p>
      </div>
      <button
        onClick={onToggleBlacklist}
        className={`rounded-lg p-3 text-center transition-colors ${
          statistics?.blacklist && statistics.blacklist.length > 0
            ? 'bg-red-50 hover:bg-red-100'
            : 'bg-gray-50'
        } ${showBlacklist ? 'ring-2 ring-red-400' : ''}`}
      >
        <p
          className={`text-lg font-bold ${
            statistics?.blacklist && statistics.blacklist.length > 0
              ? 'text-red-700'
              : 'text-gray-400'
          }`}
        >
          {statistics?.blacklist?.length ?? 0}
        </p>
        <p
          className={`text-xs ${
            statistics?.blacklist && statistics.blacklist.length > 0
              ? 'text-red-600'
              : 'text-gray-400'
          }`}
        >
          중복 의심
        </p>
      </button>
      <button
        onClick={() => onSearchByStatus(GiftCouponRedeemStatus.Rejected)}
        className={`rounded-lg p-3 text-center transition-colors ${
          statistics?.rejected ? 'bg-orange-50 hover:bg-orange-100' : 'bg-gray-50'
        } ${
          redeemStatus === GiftCouponRedeemStatus.Rejected && hasSearched
            ? 'ring-2 ring-orange-400'
            : ''
        }`}
      >
        <p
          className={`text-lg font-bold ${
            statistics?.rejected ? 'text-orange-700' : 'text-gray-400'
          }`}
        >
          {statistics?.rejected ?? 0}
        </p>
        <p className="text-xs text-orange-600">발송불가</p>
      </button>
      <button
        onClick={() => onSearchByStatus(GiftCouponRedeemStatus.Canceled)}
        className={`rounded-lg p-3 text-center transition-colors ${
          statistics?.canceled ? 'bg-gray-100 hover:bg-gray-200' : 'bg-gray-50'
        } ${
          redeemStatus === GiftCouponRedeemStatus.Canceled && hasSearched
            ? 'ring-2 ring-gray-400'
            : ''
        }`}
      >
        <p
          className={`text-lg font-bold ${
            statistics?.canceled ? 'text-gray-700' : 'text-gray-400'
          }`}
        >
          {statistics?.canceled ?? 0}
        </p>
        <p className="text-xs text-gray-500">취소</p>
      </button>
      <button
        onClick={() => onSearchByStatus(GiftCouponRedeemStatus.Disposed)}
        className={`rounded-lg p-3 text-center transition-colors ${
          statistics?.disposed ? 'bg-slate-100 hover:bg-slate-200' : 'bg-gray-50'
        } ${
          redeemStatus === GiftCouponRedeemStatus.Disposed && hasSearched
            ? 'ring-2 ring-slate-400'
            : ''
        }`}
      >
        <p
          className={`text-lg font-bold ${
            statistics?.disposed ? 'text-slate-700' : 'text-gray-400'
          }`}
        >
          {statistics?.disposed ?? 0}
        </p>
        <p className="text-xs text-slate-500">폐기</p>
      </button>
    </div>
  );
};
